import React, { Fragment } from 'react';
import { elements, colors } from '@peachjar/components';
import { css } from 'react-emotion';

import { PEACHJAR_CONTACT_NUMBER } from '../../../constants';

const { soil, blonde, jungle } = colors;
const { Note } = elements.typography;

const styles = {
  validator: css`
    padding: 1rem;
    border: 1px solid ${soil};
    border-radius: 3px;
    margin-left: -5px;
    margin-top: 0.5rem;
    background-color: ${blonde};
    display: flex;
    flex-direction: column;
  `,
  link: css`
    color: ${jungle} !important;

    &:hover {
      color: #71c174 !important;
    }
  `,
};

const CharterSchoolErrorMessage = () => (
  <div className={styles.validator}>
    <Note>
      <b>Note</b>: Please call us at {PEACHJAR_CONTACT_NUMBER} so we can help
      you get set up properly.
    </Note>
  </div>
);

export default CharterSchoolErrorMessage;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/SchoolRegistration/components/CharterSchoolErrorMessage.jsx